// extracted by mini-css-extract-plugin
module.exports = {"image":"Thumbnail_image__2KOGj"};